import styled from 'styled-components';

const Video = styled.div`
    position: relative;
    height: 236px;
    margin: 17px 0;
    & iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
`;

export default Video;



// WEBPACK FOOTER //
// ./src/kentico-blocks/Accordion/PanelGroup/StyledPanelBody/Video.jsx